module.exports = __webpack_public_path__ + "static/img/14003001.91d03af6.png";